import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { HttpClient, HttpClientModule, HttpErrorResponse } from '@angular/common/http';
import { finalize } from 'rxjs/operators';
import { AuthService } from '../../../services/auth';

interface LoginResponse {
  success: boolean;
  message: string;
}

interface SessionResponse {
  loggedIn: boolean;
}

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    FormsModule, 
    CommonModule, 
    HttpClientModule // Import HttpClientModule for HTTP requests
  ],
  templateUrl: './login.html',
  styleUrls: ['./login.css']
})
export class LoginComponent implements OnInit {
  credentials = {
    usuario: '', // Changed to match form field name
    password: ''
  };
  rememberMe = false;
  isLoading = false;
  alertMessage: string | null = null;
  alertType: 'success' | 'error' | null = null;

  constructor(private router: Router, private http: HttpClient, private authService: AuthService) {}

  ngOnInit(): void {
    // Este código se ejecuta automáticamente al cargar la pantalla de login
    this.http.get<SessionResponse>('/php/auth/verify_session.php', { withCredentials: true }).subscribe({
      next: (result) => {
        // Si el PHP dice que ya estamos logueados
        if (result.loggedIn) {
          console.log('✅ Ya hay sesión activa, redirigiendo al admin...');
          this.authService.setAuthenticated(true); // Actualizamos el estado local del servicio
          this.router.navigate(['/admin/dashboard']); // Redirigimos al dashboard
        }
      },
      error: () => {
        console.log('ℹ️ No hay sesión activa');
      }
    });
  }

  login() {
    this.isLoading = true;
    this.alertMessage = null;

    const formData = new FormData();
    formData.append('usuario', this.credentials.usuario);
    formData.append('password', this.credentials.password);
    if (this.rememberMe) {
      formData.append('recordar', 'on');
    }

    this.http.post<LoginResponse>('/php/auth/login.php', formData, { withCredentials: true })
      .pipe(
        finalize(() => {
          this.isLoading = false;
        })
      )
      .subscribe({
        next: (result) => {
          if (result.success) {
            this.alertType = 'success';
            this.alertMessage = '✅ Login exitoso. Redirigiendo...';
            console.log('✅ Login exitoso, redirigiendo al admin...');

            // 1. AVISAR AL SERVICIO (Asegúrate de tener este método en tu servicio Auth)
            this.authService.setAuthenticated(true);

            setTimeout(() => {
              // The original JS redirects to index.html, in Angular we navigate to a route
              this.router.navigate(['/admin/dashboard']);
            }, 1000);
          }
        },
        error: (error: HttpErrorResponse) => {
          this.alertType = 'error';
          
          // Lógica para diferenciar errores
          if (error.status === 401) {
            // Leemos el mensaje "Contraseña incorrecta" que viene del servidor
            this.alertMessage = `❌ ${error.error.message || 'Credenciales inválidas'}`;
          } else if (error.status === 0) {
            this.alertMessage = '⚠️ No hay conexión con el servidor.';
          } else {
            this.alertMessage = '❌ Error inesperado. Intente nuevamente.';
          }
          
          console.error('Detalle del error:', error);
        }
      });
  }
}
